import {AppLocalStorage} from "@services/utils";

export default function () {
  return {
    user: JSON.parse(AppLocalStorage.getItem('hotelAuth.user')),
    token: AppLocalStorage.getItem('hotelAuth.token'),
    expire_time: Number(AppLocalStorage.getItem('hotelAuth.expire_time'))
  }
}
